var React = require('react');
var numeral = require('numeral');

// config locale
numeral.register('locale', 'pt-br', {
    delimiters: {
        thousands: '.',
        decimal: ','
    },
    abbreviations: {
        thousand: 'mil',
        million: 'milhões',
        billion: 'b',
        trillion: 't'
    },
    ordinal: function (number) {
        return 'º';
    },
    currency: {
        symbol: 'R$'
    }
});

numeral.locale('pt-br');
numeral.defaultFormat('$0,0.00');

var PriceFormatter = React.createClass({

	render: function() {
		var me = this, value = me.props.data;

		return (
			<span style={me.props.style ? me.props.style : null}>
                {numeral(value / 100).format()}
            </span>
		);
	}

});

module.exports = PriceFormatter;


// WEBPACK FOOTER //
// ./src/components/Formatters/PriceFormatter.jsx